import { Messages } from '../../codegen/Localize';
import {
  ActionHelpers,
  standardActionErrorMsg,
  standardActionSuccessMsg
} from '../../commonInfra/contentActions/ActionHelpers';
import { IErrorItem } from '../../commonInfra/contentActions/MultipleItemResult';
import { FlowErrors } from '../../flow/services/FlowErrors';
import { FlowBaseInfo } from '../models/FlowInfo';
import { Set } from '../models/Set';
import { Flows } from '../resources/Flows';
import { IResult } from '../../httpClient/serverApi/types/IResponse';

export namespace ChangeFlowDescriptionAction {

  export function execute(flow: FlowBaseInfo, newDescription: string): ng.IPromise<IResult> {

    return Flows.setDescription(flow.id, newDescription).then((result: IResult) => {
        ActionHelpers.displayStandardToastsForResult(
          Set.singletonForIdItem(flow),
          result,
          {
            success: standardActionSuccessMsg(Messages.editDescriptionSuccessful),
            error: standardActionErrorMsg(Messages.editDescriptionFailure),
          },
          (errorItem: IErrorItem<FlowBaseInfo>) => FlowErrors.errorDetailsFor(errorItem)
        );
        return result;
    });
  }
}
